import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * shadcn/ui class-merge helper.
 *
 * Ported from the `update-design` reference branch, MINUS its
 * `extendTailwindMerge` block: that block teaches tailwind-merge about the
 * repo type scale (`text-body-14` …). `src/styles/type-scale.ts` now exists
 * here, but the scale is NOT bridged into Tailwind as `--text-*` — the
 * Typography seam applies it as inline styles, so no `text-body-14` utility
 * is ever emitted and the extension would classify class names nothing
 * writes. Bring it back with the change that makes the scale a set of
 * utilities; the reference branch's version is the one to copy.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
